module.exports = __webpack_public_path__ + "img/will-previous-relationship.432b4a55.svg";